// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Calendar icon.
 * @param {IconProps} props - The IconProps for the CalendarIcon component.
 * @returns {ReactElement} The CalendarIcon component.
 */

export const TimeRecoveryIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;

  return (
    <Icon width='32' height='33' viewBox='0 0 32 33' fill='transparent' color={color} {...rest} id='time-recovery'>
      <path
        d='M15.8301 8.995V17.655L19.199 21.025'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.3019 2.22498C4.88375 4.48498 1.08502 9.83497 1.08502 16.075C1.08502 21.255 3.70415 25.815 7.69281 28.515C10.082 30.135 12.971 31.075 16.08 31.075C23.0077 31.075 28.8457 26.375 30.5652 19.985'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeDasharray='3.92 3.92'
      />
      <path
        d='M28.3359 7.43495C25.6168 3.58495 21.1383 1.07495 16.07 1.07495C7.79276 1.07495 1.07501 7.79495 1.07501 16.075C1.07501 22.025 4.53386 27.165 9.55218 29.585'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.9773 6.1349L27.5661 2.9549C28.3259 2.2749 29.5355 2.6449 29.8054 3.6249L31.025 8.1149C31.3049 9.1449 30.3652 10.0849 29.3355 9.8049L24.5272 8.4949C23.4775 8.2049 23.1576 6.8649 23.9773 6.1349Z'
        fill='currentColor'
      />
    </Icon>
  );
};
